"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPopper = exports.StyledNavItem = exports.NavigationBarContainer = void 0;
var _Popper = require("../../Utils/Popper/Popper");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledNavItem = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tfont-size: 1.5rem;\n\tcolor: ", ";\n\tspan {\n\t\tcolor: inherit;\n\t}\n"])), function (_ref) {
  var selected = _ref.selected,
    theme = _ref.theme;
  return selected ? theme.colors.primary : theme.colors.dark;
});
exports.StyledNavItem = StyledNavItem;
var NavigationBarContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tborder-top-left-radius: 15px;\n\tborder-top-right-radius: 15px;\n\tpadding: 0.781rem 0;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\twidth: 100%;\n\theight: fit-content;\n\t", ";\n\tbox-shadow: -4px -2px 4px 0 rgba(0, 0, 0, 0.16);\n"])), (0, _styledSystem.variant)({
  prop: 'color',
  scale: 'backgrounds'
}));
exports.NavigationBarContainer = NavigationBarContainer;
var StyledPopper = (0, _styledComponents["default"])(_Popper.Popper)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tfont-size: 0.8rem;\n\tcolor: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.spanishGray;
});
exports.StyledPopper = StyledPopper;